import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/Dancebrite_Primary_Logo-No_BG.png";
import icon from "../../assets/images/fav.png";
import { rgba } from "../../helpers";

const AdminSideBar = ({ isMenuOpen, setMenuOpen = () => {} }) => {
  const { lang } = useSelector((state) => state?.langProvider);

  const adminSidebarMenu = [
    {
      _id: "Dashboard",
      menuTitle: "Dashboard",
      menuData: [
        {
          _id: "Dashboard",
          menuLabel: "Dashboard",
          menuLink: `/${lang}/admin/dashboard`,
          menuIcon: "fa-light fa-chart-pie",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "Events",
      menuTitle: "Events",
      menuData: [
        {
          _id: "Events",
          menuLabel: "Events",
          menuLink: `/${lang}/admin/events`,
          menuIcon: "fa-light fa-calendar-days",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "Organization",
      menuTitle: "Organization",
      menuData: [
        {
          _id: "organization",
          menuLabel: "Organizations",
          menuLink: `/${lang}/admin/organization`,
          menuIcon: "fa-regular fa-building",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "Artists",
      menuTitle: "Artists",
      menuData: [
        {
          _id: "Artists",
          menuLabel: "Artist",
          menuLink: `/${lang}/admin/artist`,
          menuIcon: "fa-light fa-user-music",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "users",
      menuTitle: "User Management",
      menuData: [
        {
          _id: "users",
          menuLabel: "Users",
          menuLink: `/${lang}/admin/users`,
          menuIcon: "fa-regular fa-users",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "Events",
      menuTitle: "Event Mangement",
      menuData: [
        // {
        //   _id: "Category",
        //   menuLabel: "Categories",
        //   menuLink: "/${lang}/admin/categories",
        //   menuIcon: "fa-regular fa-list",
        //   menuIconColor: "text-primary",
        // },
        // {
        //   _id: "Collections",
        //   menuLabel: "Collections",
        //   menuLink: `/${lang}/admin/collections`,
        //   menuIcon: "fa-regular fa-grid",
        //   menuIconColor: "text-primary",
        // },
        {
          _id: "Tickets",
          menuLabel: "Tickets",
          menuLink: `/${lang}/admin/tickets`,
          menuIcon: "fa-regular fa-ticket",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "order",
      menuTitle: "Order Management",
      menuData: [
        {
          _id: "order",
          menuLabel: "Orders",
          menuLink: `/${lang}/admin/order`,
          menuIcon: "fa-regular fa-box",
          menuIconColor: "text-primary",
        },
      ],
    },
    {
      _id: "transaction",
      menuTitle: "Transaction Management",
      menuData: [
        {
          _id: "transaction",
          menuLabel: "Transactions",
          menuLink: `/${lang}/admin/transaction`,
          menuIcon: "fa-regular fa-sack-dollar",
          menuIconColor: "text-primary",
        },
      ],
    },
    // {
    //   _id: "reports",
    //   menuTitle: "Report Mangement",
    //   menuData: [
    //     {
    //       _id: "reports",
    //       menuLabel: "Reports",
    //       menuLink: `/${lang}/admin/reports`,
    //       menuIcon: "fa-regular fa-address-book",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "contacts",
    //       menuLabel: "Contacts",
    //       menuLink: `/${lang}/admin/contacts`,
    //       menuIcon: "fa-regular fa-address-book",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "faq",
    //       menuLabel: "FAQ",
    //       menuLink: `/${lang}/admin/faq`,
    //       menuIcon: "fa-regular fa-address-book",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    // },
    // {
    //   _id: "cms",
    //   menuTitle: "CMS Mangement",
    //   menuData: [
    //     {
    //       _id: "Emailtemplate",
    //       menuLabel: "Email template",
    //       menuLink: `/${lang}/admin/email-template`,
    //       menuIcon: "fa-regular fa-envelope",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "pages",
    //       menuLabel: "Pages",
    //       menuLink: `/${lang}/admin/page`,
    //       menuIcon: "fa-regular fa-file",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "Settings",
    //       menuLabel: "Settings",
    //       menuLink: `/${lang}/admin/site-settings`,
    //       menuIcon: "fa-regular fa-gear",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    // },
  ];

  return (
    <div className="relative w-full">
      <div
        className={
          "relative flex flex-col gap-2 overflow-auto scroll-smooth scrollbar scrollbar-1 h-full max-h-[calc(100vh-9rem)] transition-all duration-100" +
          (isMenuOpen ? "" : "divide-transparent")
        }
      >
        {Array.isArray(adminSidebarMenu) &&
          adminSidebarMenu?.map((item, index) => {
            if (item) {
              return <SidebarMenuBlocks key={item._id} menuTitle={item.menuTitle} menuData={item.menuData} isMenuOpen={isMenuOpen} icon={icon} />;
            }
            return null;
          })}
      </div>
    </div>
  );
};

export default AdminSideBar;
